import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../utils/routes'
import { Button } from '../../System'
import { FOREVER } from '../../utils/stripePrices'
import { StyledCurrentPlanCard } from '..'
import useSegment from '../../utils/useSegment'

type Props = {
  price?: number;
  title: string;
  interval?: string;
  description: string;
  showUpgrade?: boolean;
  setShowModal: (showModal) => void;
  renews?: boolean;
}

const CurrentPlanCard: FC<Props> = ({
  price,
  title,
  interval,
  description,
  showUpgrade,
  setShowModal,
  renews
}) => {
  const history = useHistory()
  const { track } = useSegment()

  const handleShowCancelModal = () => {
    setShowModal(true)
    track('Clicked Unsubscribe')
  }

  return (
    <StyledCurrentPlanCard plan={title}>
      <>
        <div className="current-plan-main">
          <div className="current-plan-gradient" />
          <div className="current-plan-info">
            <div className="current-plan-frequency">
              <p className="plan">{title}</p>
              <div>
                <p className="price">
                  ${price || 0}
                  {interval && <span className="interval">/{interval}</span>}
                </p>
              </div>
            </div>
            <p className="current-plan-description">{description}</p>
            {showUpgrade && (
              <Button
                theme="solid"
                onClick={() => history.push(ROUTES.user.settings.plan)}
                className="upgrade"
              >
                Upgrade
              </Button>
            )}
          </div>
        </div>
        {title !== FOREVER && renews && (
          <button className="unsubscribe" onClick={() => handleShowCancelModal()}>
            Unsubscribe
          </button>
        )}
      </>
    </StyledCurrentPlanCard>
  )
}

export default CurrentPlanCard
